import { Box, Button, Typography, Divider } from '@mui/material';
import dayjs from 'dayjs';
import { useTranslation } from 'next-i18next';

import { InfoRoundSelectedBox } from './style';

import { ICPDCourseRound } from 'src/interfaces';

interface Props {
  selectedRound?: ICPDCourseRound;
  handleRemoveSelectedRound: () => void;
}

const InfoRoundSelected = ({ selectedRound, handleRemoveSelectedRound }: Props) => {
  const { t } = useTranslation();
  const toShortDateFormat = (date: Date): string => dayjs(date).format('DD/MM/BBBB');

  return (
    <InfoRoundSelectedBox>
      <Box className="select-round-date-box">
        <Box className="round-date-box">
          <Typography className="round-date-text" fontWeight="600">
            {'วันที่เริ่มรอบอบรม: '}
          </Typography>
          <Typography
            className="round-date-text"
            sx={{
              color: selectedRound ? 'primary.main' : 'errorDark.main',
            }}
          >
            {selectedRound
              ? t('cpd_enrollment.round.selected_round_start_date', {
                date: toShortDateFormat(selectedRound.roundDate),
              })
              : t('cpd_enrollment.round.please_select_training_round')}
          </Typography>
        </Box>
        <Divider className="divider-vertical" orientation="vertical" flexItem />
        <Box className="round-date-box">
          <Typography className="round-date-text" fontWeight="600">
            {'วันที่จบรอบอบรม: '}
          </Typography>
          <Typography
            className="round-date-text"
            sx={{
              color: selectedRound ? 'primary.main' : 'rgba(0, 0, 0, 0.87)',
            }}
          >
            {selectedRound
              ? t('cpd_enrollment.round.selected_round_end_date', {
                date: toShortDateFormat(selectedRound.expiredDate),
              })
              : '-'}
          </Typography>
        </Box>
        <Button
          variant="outlined"
          color="error"
          className="cancel-selected-round-button"
          sx={{ borderColor: 'errorDark.main' }}
          onClick={handleRemoveSelectedRound}
          disabled={!selectedRound}
        >
          {t('cpd_enrollment.round.cancel_selected_round')}
        </Button>
      </Box>
    </InfoRoundSelectedBox>
  );
};

export default InfoRoundSelected;
